import {Price} from '@wix/ambassador-ecom-v1-order-payment-request/types';

export class PaymentRequestPriceModel {
  public amount: number;
  public formattedAmount: string;
  constructor(price?: Price | null) {
    this.amount = Number(price?.amount) || 0;
    this.formattedAmount = price?.formattedAmount ?? '';
  }
}
